import { render, staticRenderFns } from "./preStartupReviewItemDetail.vue?vue&type=template&id=cd8d7556"
import script from "./preStartupReviewItemDetail.vue?vue&type=script&lang=js"
export * from "./preStartupReviewItemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd8d7556')) {
      api.createRecord('cd8d7556', component.options)
    } else {
      api.reload('cd8d7556', component.options)
    }
    module.hot.accept("./preStartupReviewItemDetail.vue?vue&type=template&id=cd8d7556", function () {
      api.rerender('cd8d7556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/psr/preStartupReviewItemDetail.vue"
export default component.exports